import { ContentBlockTypes } from 'api/landingPageTheme'
import { buildTranslate } from 'locales'

const t = buildTranslate('cms.content.app_home_page.content.edit_block.content')

export const getContentTabAvailable = (type: ContentBlockTypes): boolean => {
  const editContentTabsAvailable: ContentBlockTypes[] = [
    'featured_content',
    'external_form',
    'personalized_text',
    'featured_content_carousel',
    'game',
  ]
  return editContentTabsAvailable.includes(type)
}

export const getStyleTabAvailable = (type: ContentBlockTypes): boolean => {
  return type !== 'featured_content_carousel'
}

export const getBadgeContent = (
  type: ContentBlockTypes
): { badges: string[]; badgeDescriptions: string[] } => {
  const hasImages = [
    'featured_content',
    'external_form',
    'featured_content_carousel',
    'game',
  ].includes(type)

  const badges = [t('badges.app_only')]
  const badgeDescriptions: string[] = []

  if (hasImages) {
    const baseBadges = [
      t('badges.wide_1800_px'),
      t('badges.any_height'),
      t('badges.jpg'),
      t('badges.png'),
    ]

    badges.push(...baseBadges)
    badges.push(t('badges.gif'))

    badgeDescriptions.push(
      t('badges.description.png'),
      t('badges.description.gif')
    )
  }

  return {
    badges,
    badgeDescriptions,
  }
}
